export const ordenateArrayByName = (array) => {
    if (array?.length < 1) return
    return array?.map((item) => {
      return item
    }).sort((a, b) => {
      if (a.name > b.name) return 1
      if (a.name < b.name) return -1
      return 0
    })
  }